let googleMap, mapList, mapLegend;
let xPrizeMap = {
    previousMarker: null,
    previousUniqueCluster: null,
    focusedStrokeWeight: 3,
    focusedStrokeColor: "#fff",
    focusedScale: 10,
    unfocusedStrokeWeight: 0.8,
    unfocusedScale: 6.5,
    isFullScreen: false,
    InitialStateChanged: false,
    IsMarkerSelected: false,
    filteredPlace: null,
    mobileToggle: false
};
let xPrizeStyles = [{
    "featureType": "water",
    "stylers": [{
        "color": "#484848"
    }]
}, {
    "featureType": "landscape",
    "stylers": [{
        "color": "#151515"
    }]
}, {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text",
    "stylers": [{
        "color": "#484848"
    }]
}, {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.stroke",
    "stylers": [{
        "color": "#000"
    }]
}, {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [{
        "color": "#000"
    }]
}, {
    "featureType": "road",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "poi",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "transit",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "administrative.country",
    "elementType": "geometry.stroke",
    "stylers": [{
        "visibility": "off"
    }]
}, {
    "featureType": "administrative.province",
    "elementType": "geometry.stroke",
    "stylers": [{
        "visibility": "off"
    }]
},{
    "featureType": "administrative.country",
    "elementType": "labels.text.fill",
    "stylers": [{
        "color": "#484848"
    }]
}, {
    "featureType": "administrative.country",
    "elementType": "labels.text.stroke",
    "stylers": [{
        "color": "#232323"
    }]

}, {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [{
        "color": "#484848"
    }]
}, {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.stroke",
    "stylers": [{
        "color": "#232323"
    }]
}, {
    "featureType": "administrative.locality",
    "elementType": "labels.text.fill",
    "stylers": [{
        "color": "#484848"
    }]
}, {
    "featureType": "administrative.locality",
    "elementType": "labels.text.stroke",
    "stylers": [{
        "color": "#232323"
    }]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text.fill",
    "stylers": [{
        "color": "#484848"
    }]
}, {
    "featureType": "administrative.neighborhood",
    "elementType": "labels.text.stroke",
    "stylers": [{
        "color": "#232323"
    }]
}, {
    "featureType": "administrative.province",
    "elementType": "labels.text.fill",
    "stylers": [{
        "color": "#484848"
    }]
}, {
    "featureType": "administrative.province",
    "elementType": "labels.text.stroke",
    "stylers": [{
        "color": "#232323"
    }]
}
];


class MapLegendComponent {
    constructor(teams, legendItems) {
        this.legendsTemplate(teams, legendItems);
    }

    legendsTemplate(teams, legendItems) {

        var items = (legendItems != null)
                    ? legendItems.map(i => {
                            var item = {
                                text: i.title.toUpperCase(),
                                color: i.color
                            };

                            return item;
                        })
                    : this.getlegendItems(teams);

        $('#legend-wrapper').html('');
        let source = document.getElementContextById("legendTemplate").innerHTML;
        let template = Handlebars.compile(source);
        let context = {
            legendItems: items
        };
        let html = template(context);
        $('#legend-wrapper').html(html);
    }

    selectProps(...props) {
        return function (obj) {
            const newObj = {};
            props.forEach(name => {
                newObj[name] = obj[name];
            });
            return newObj;
        }
    }

    selectPropsList(arr, prop, prop2, prop3) {
        return arr.reduce((a, d) => {
            if (d[prop] != null && !a.includes(d[prop][prop2])) {
                if (d[prop].length > 0) {
                    d[prop].forEach(function (v) {
                        if (!a.includes(v[prop2])) {
                            var item = {
                                text: v[prop2],
                                color: v[prop3]
                            }
                            a.push(item)
                        }
                    })
                }
            }
            return a;
        }, []);
    }

    getlegendItems(teams) {

        var legendItems = [];

        //Teams
        let newArr = teams.map(this.selectProps("status", "color"));
        const teamColors = [...new Map(newArr.map(item => [item['status'], item])).values()];

        teamColors.forEach(function (v) {
            legendItems.push({
                text: v.status.toUpperCase(),
                color: v.color
            });
        })

        //Achievements
        const achievementColors = this.selectPropsList(teams, "achievements", "displayName", "color");
        achievementColors.forEach(function (v) {
            legendItems.push({
                text: v.text.toUpperCase(),
                color: v.color
            });
        })

        return legendItems.filter(
            (obj, index) => legendItems.findIndex((item) => item.text === obj.text) === index
        );
    }
}
class GoogleMapViewComponent {
    map;
    markerList = [];
    markerCluster;
    detailsZoomLevel = 5;

    constructor(teams) {
        this.loadInitialMap(teams);
    }
    static getInstance(teams) {
        if (!this.instance) {
            this.instance = new GoogleMapViewComponent(teams);
        }
        return this.instance;
    }
    /*** Load all or filtered teams on the map. */
    loadInitialMap(teamsList) {

        this.map = new google.maps.Map(document.getElementById('map'), {
            center: new google.maps.LatLng(0, 0),
            zoom: 2,
            minZoom: 2,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: xPrizeStyles,
            streetViewControl: false,
            mapTypeControl: false,
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_BOTTOM,
            },
            fullscreenControl: true
        });

        google.maps.event.addListener(map, 'mouseover', function (event) {
            this.setOptions({
                scrollwheel: true
            });
        });
        var locationButton = this.LocateMe();
        this.map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(locationButton);
        if (teamsList === teams) {
            xPrizeMap.InitialStateChanged = false;
        } else {
            xPrizeMap.InitialStateChanged = true;
        }
        locationButton.addEventListener("click", () => {
            // Try HTML5 geolocation.
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const pos = {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude,
                        };
                        let marker = new google.maps.Marker({
                            position: new google.maps.LatLng(pos.lat, pos.lng),
                            icon: {
                                path: google.maps.SymbolPath.CIRCLE,
                                scale: xPrizeMap.focusedScale,
                                fillColor: '#1da1f2',
                                fillOpacity: 1,
                                strokeWeight: xPrizeMap.focusedStrokeWeight
                            },
                            map: map
                        });
                        let icon = marker.getIcon();
                        icon.fillColor = icon.fillColor;
                        icon.path = google.maps.SymbolPath.CIRCLE;
                        icon.scale = xPrizeMap.focusedScale;
                        icon.strokeColor = xPrizeMap.focusedStrokeColor;
                        icon.strokeWeight = xPrizeMap.focusedStrokeWeight;
                        marker.setIcon(icon);
                        this.map.setCenter(marker.position);
                        this.map.setZoom(10);
                    },
                    () => {
                        handleLocationError(true, map.getCenter());
                    });
            } else {
                // Browser doesn't support Geolocation
                handleLocationError(false, infoWindow, map.getCenter());
            }
        });

        const renderer = {
            render: ({ count, position }) =>

                new google.maps.Marker({
                    label: { text: String(count), color: "#ffffff", fontSize: "14px", fontWeight: "600" },
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 10.5,
                        fillColor: "#DD00F0",
                        fillOpacity: 0.7,
                        strokeWeight: 0.4
                    },
                    position,
                    // adjust zIndex to be above other markers
                    zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                })

        };


        const onClusterClickHandler = function (e, cluster, map) {

            if (cluster.markers !== null && cluster.markers.length >= 2) {

                let uniqueMarkersList = cluster.markers.filter((value, index, self) =>
                    index === self.findIndex((t) => (
                        t.getPosition().lat() === value.getPosition().lat() && t.getPosition().lng() === value.getPosition().lng()
                    ))
                );

                if (uniqueMarkersList.length === 1) {

                    var previousCluster = xPrizeMap.previousUniqueCluster;
                    var currentCluster = uniqueMarkersList[0];

                    //Stops the ability to click the same cluster twice.
                    if (previousCluster !== null && currentCluster != null) {
                        if (currentCluster.getPosition().lat() === previousCluster.getPosition().lat() && currentCluster.getPosition().lng() === previousCluster.getPosition().lng()) {
                            return;
                        }
                    }
                    
                    xPrizeMap.previousUniqueCluster = currentCluster;
                    mapList.filterByClusterMarkers(cluster.markers);

                    map.setZoom(12);
                    map.panTo(currentCluster.getPosition());

                    return;

                }
            }

           markerClusterer.defaultOnClusterClickHandler(e, cluster, map);
        }

        
        this.markerCluster = new markerClusterer.MarkerClusterer
        (
            {
                map: this.map,
                renderer: renderer,
                onClusterClick: onClusterClickHandler
            }
        );

        this.loadMapMarkers(teamsList);        
    }
    //Google Methods
    clearMapMarkers() {

        for (let i = 0; i < this.markerList.length; i++) {
            this.markerList[i].setMap(null);
        }
        this.markerList = [];

    }
    loadMapMarkers(teamsList) {
        this.clearMapMarkers();
        for (let i = 0; i < teamsList.length; i++) {
            this.addMapMarker(teamsList[i], i);
        }

        this.markerCluster.clearMarkers();
        this.markerCluster.addMarkers(this.markerList);
    }
    getMapMarker(teamId) {
        return this.markerList.filter(o => o.teamId === teamId)[0]
    }
    recenterMap() {
        var lat = (xPrizeMap.isFullScreen) ? 300 : 0;
        this.map.setCenter(new google.maps.LatLng(0, lat))
        this.map.setZoom(2);
    }

    getMarkerColor(team) {
        if (team.achievements) {

            //team.achievements.sort(function (a, b) {
            //    return new Date(b.createDate) - new Date(a.createDate);
            //});

            return team.achievements[0].color;
        } else {
            return team.color;
        }
    }

    addMapMarker(team, index) {
        var self = this;
        let marker = new google.maps.Marker({
            position: new google.maps.LatLng(team.latitude, team.longitude),
            icon: {
                path: google.maps.SymbolPath.CIRCLE,
                scale: xPrizeMap.unfocusedScale,
                fillColor: this.getMarkerColor(team),
                fillOpacity: 1,
                strokeWeight: xPrizeMap.unfocusedStrokeWeight
            },
            teamId: team.id
        });

        this.markerList.push(marker); // add each marker to array

        google.maps.event.addListener(marker, 'click', (function (marker, i) {
            return function () {
                if (xPrizeMap.previousMarker !== marker) {
                    self.navigateToMarker(marker);
                }
                if (isMobile()) {
                    mapList.markerMobileEventHandler(marker, team.id);
                } else {
                    //calls map instances for update
                    mapList.markerEventHandler(marker, team.id);
                }
            }
        })(marker, index));
    }
    LocateMe() {
        let button = $('<button id="map-loction-button"><i class="fa fa-location-arrow"></i></button>');
        button.css({
            "background": "none rgb(255, 255, 255)",
            "border": "0px",
            "margin": "10px",
            "text-transform": "none",
            "cursor": "pointer",
            "user-select": "none",
            "border-radius": "2px",
            "height": "40px",
            "width": "40px",
            "box-shadow": "rgb(0 0 0 / 30%) 0px 1px 4px -1px",
            "overflow": "hidden",
            "right": "0px"
        });
        let locationButton = $('<div></div>').append(button);
        return locationButton.get(0);
    }
    setMapOnAll() {
        for (let i = 0; i < this.markerList.length; i++) {
            this.markerList[i].setMap(this.map);
        }
    }
    removeStrokeFromMarker() {
        let icon = xPrizeMap.previousMarker.getIcon();
        icon.path = google.maps.SymbolPath.CIRCLE;
        icon.scale = xPrizeMap.unfocusedScale;
        icon.strokeColor = icon.fillColor;
        icon.strokeWeight = xPrizeMap.unfocusedStrokeWeight;
        xPrizeMap.previousMarker.setIcon(icon);
        return icon;
    }
    navigateToMarker(currentMarker) {
        //remove stroke from previously clicked icon
        if (xPrizeMap.previousMarker != null) {
            var previousIcon = this.removeStrokeFromMarker();
            xPrizeMap.previousMarker.setIcon(previousIcon);
        }

        if (currentMarker) {
            //setup icon
            let icon = currentMarker.getIcon();
            icon.fillColor = icon.fillColor;
            icon.path = google.maps.SymbolPath.CIRCLE;
            icon.scale = xPrizeMap.focusedScale;
            icon.strokeColor = xPrizeMap.focusedStrokeColor;
            icon.strokeWeight = xPrizeMap.focusedStrokeWeight;
            currentMarker.setIcon(icon);
            //set zoom and go to marker
            this.map.setZoom(this.detailsZoomLevel);
            this.map.panTo(currentMarker.getPosition());
            //set current marker as previous xPrizeMap object
            xPrizeMap.previousMarker = currentMarker;
            xPrizeMap.InitialStateChanged = true;
        }
    }
}
class MapListComponent {
    btnMapHeaderElement = "map-header-map-btn";
    btnDetailsElement = "map-header-details-btn";
    btnMapSearchElement = "map-search-btn";
    btnMapBackElement = "map-back-btn";
    mapTotalCountElement = "map-list-total-count-section";
    mapElement = "map";
    detailsElement = "detailsPane";
    btnMapSearchElement = "map-search-btn"
    btnlistElement = "mobile-list-btn";
    btnMapElement = "mobile-map-btn";
    listOuterElement = "list-body";
    listBodyElement = "list-body";
    filterTeamBtn = "filterTeamBtn"
    filterDropdown = "filterDropdown";
    upChevron = "filterArrowUp";
    downChevron = "filterArrowDown";
    panelSearch = "panel-search";
    teams;
    constructor(teams) {
        this.teams = teams;
        this.mapList(teams, false);
        this.AddEventListeners();
    }
    static getInstance(teams) {
        if (!this.instance) {
            this.instance = new MapListComponent(teams);
        }
        return this.instance;
    }
    AddEventListeners() {
        var self = this;
        $(document).on('click', '#map-search-btn', function () {
            self.searchPanelState();
        });
        $(document).on('click', '#filterTeamBtn', function () {
            self.showFilter();
        });
        $(document).on('click', '#mobile-list-btn', function () {
            self.toggleEventHandler();
        });
        $(document).on('click', '#mobile-map-btn', function () {
            self.toggleEventHandler();
        });
        $(document).on('click', '#map-header-map-btn', function () {
            self.teamDetailsToggleMobileEventHandler();
        });
        $(document).on('click', '#map-header-details-btn', function () {
            self.teamDetailsToggleMobileEventHandler();
        });
        $(document).on('change', '#filterDropdown', function () {
            if (isMobile()) {
                self.filterMobileEventHandler();
            } else {
                self.filterEventHandler();
            }
        });
        $(document).on('keyup', '#panel-search', function () {
            self.search();
        });
        $(document).on('click', '.list-item', function () {
            //TODO: Refactor
            if (isMobile()) {
                self.teamsDetailsMobileEventHandler(parseInt(this.id), 'list');
            } else {
                self.teamsDetailsEventHandler(parseInt(this.id), 'list');
            }
        });
        $(document).on('click', '.result-item-teams', function () {
            //TODO: Refactor
            if (isMobile()) {
                self.teamsDetailsMobileEventHandler(parseInt(this.id), 'list');
            } else {
                self.teamsDetailsEventHandler(parseInt(this.id), 'list');
            }
        });
        $(document).on('click', '.result-item-place', function () {

            if (isMobile()) {
                self.filterMobileBasedOnPlaceEventHandler(this.dataset.place);
            }
            else {
                self.filterBasedOnPlaceEventHandler(this.dataset.place);
            } 
        });
        $(document).on('click', '#map-back-btn', function () {
            if (isMobile()) {
                self.goBackMobileEventHandler();
            } else {
                self.goBackEventHandler();
            }
        });
        $(document).on('click', '#clear-btn', function () {
            if (isMobile()) {
                self.resetMobileListEventHandler();
            } else {
                self.resetListEventHandler();
            }
        });
        $(document).on('search', '#search-box', function () {
            self.searchBoxClearEventHandler();
        });
    }

    toggleEventHandler() {
        let mBtnMap = document.getElementById(this.btnMapElement);
        if (mBtnMap.style.display === "none" || mBtnMap.style.display === "") {
            hideElement(this.btnlistElement)
            showElement(this.listOuterElement);
            showElement(this.btnMapElement);
            hideElement(this.mapElement);
            xPrizeMap.mobileToggle = true;
        } else {
            xPrizeMap.mobileToggle = false;
            showElementFlex(this.btnlistElement);
            hideElement(this.listOuterElement);
            hideElement(this.btnMapElement);
            showElement(this.mapElement);
        }
    }

    // TODO: it seems like this "marker" thing isn't being used
    markerEventHandler(marker, teamId) {
        this.teamsDetailsEventHandler(teamId, 'marker');
    }

    markerMobileEventHandler(marker, teamId) {
        this.markerEventHandler(marker, teamId);
        this.teamDetailsMobileState();
    }

    teamsDetailsEventHandler(teamId, caller) {
        $('#list-body').html('');
        let selectedTeam = teams.filter(obj => {
            return obj.id === teamId
        });
        let source = document.getElementInnerHtmlByIdContext("detailsTemplate");
        let template = Handlebars.compile(source);
        let context = {
            selectedTeam: selectedTeam
        };
        let html = template(context);
        $('#list-body').html(html);
        // $('#list-header').hide();
        if (caller !== "marker") {
            this.listTeamClick(teamId);
        }
        xPrizeMap.IsMarkerSelected = false;

        hideElement(this.filterTeamBtn);
        hideElement(this.btnMapSearchElement);
        hideElement(this.mapTotalCountElement);
        showElementFlex(this.btnMapBackElement);
        hideElement(this.panelSearch);
        detailsToggle(50);
    }

    teamsDetailsMobileEventHandler(teamId, caller) {
        this.teamsDetailsEventHandler(teamId, caller);
        this.teamDetailsMobileState();
    }

    teamDetailsMobileState() {
        let mBtnDetailsElement = document.getElementContextById(this.btnDetailsElement);

        if (mBtnDetailsElement !== null) {
            if (mBtnDetailsElement.style.display === "none") {
                showElement(this.btnMapHeaderElement); //show map btn
                hideElement(this.mapElement); //hide map
                hideElement(this.btnDetailsElement); //hide details btn
                showElement(this.detailsElement); //show details pane
            } else {
                hideElement(this.btnMapHeaderElement); //hide map btn
                showElement(this.mapElement); //show map
                showElement(this.btnDetailsElement); //show details btn
                hideElement(this.detailsElement); //hide details pane
            }
            xPrizeMap.IsMarkerSelected = true;
        }
    }

    teamDetailsToggleMobileEventHandler() {
        let mBtnMap = document.getElementContextById(this.btnMapHeaderElement);
        if (mBtnMap.style.display === "inherit" || mBtnMap.style.display === "") {
            hideElement(this.btnMapElement); //hide map btn
            hideElement(this.detailsElement); //hide details pane
            hideElement(this.btnMapHeaderElement); //hide map btn
            showElement(this.mapElement); //show map
            showElement(this.btnDetailsElement); //show details btn
        } else {
            showElement(this.btnMapElement); //show map btn
            hideElement(this.mapElement); //hide map
            hideElement(this.btnDetailsElement); //hide details btn
            showElement(this.detailsElement); //show details pane
            showElement(this.btnMapHeaderElement); //show map btn
        }
    }

    goBackEventHandler() {

        this.filterEventHandler();
        this.refreshPanelState();
        hideElement(this.btnMapElement);
        hideElement(this.btnlistElement);
        googleMap.recenterMap();


        showElementFlex(this.filterTeamBtn);
        showElementFlex(this.btnMapSearchElement);
        showElementFlex(this.mapTotalCountElement);
        hideElement(this.btnMapBackElement);
        detailsToggle(100);
        xPrizeMap.previousUniqueCluster = null;
    }

    goBackMobileEventHandler() {
        this.goBackEventHandler();
        this.verifyPanelState();
    }

    filterBasedOnPlaceEventHandler(place) {
        var teams = this.teams;
        const filteredTeams = teams.filter(o => o.address.toLowerCase().includes(place.toLowerCase()));
        if (filteredTeams.length === 1) {
            this.teamsDetailsEventHandler(filteredTeams[0].id, '');
        } else {
            this.mapList(filteredTeams, true);
            this.listTeamClick(filteredTeams[0].id);
            xPrizeMap.filteredPlace = place;
        }
        showElementFlex('clear-btn');
        this.clearSearchInput();
        hideElement(this.panelSearch);
    }

    filterMobileBasedOnPlaceEventHandler(place) {
        this.filterBasedOnPlaceEventHandler(place);
        this.teamDetailsMobileState();
    }

    filterByClusterMarkers(markers) { 
        let result = this.teams.filter(t => markers.some(m => t.id === m.teamId));
        this.navigateBackToList();
        this.mapList(result, true); //rebuild team list
        showElementFlex('clear-btn');
    }

    filterEventHandler() {
        var teams = this.teams;

        const checkedValues = [...document.querySelectorAll('.listFilter')].filter(input => input.checked).map(input => input.value);
        if (checkedValues.length === 0) { // if no checkboxes selected
            this.listCount(this.teams, false);
            this.listBody(this.teams, false); //rebuild team list
            googleMap.loadMapMarkers(this.teams) // load map w/ inital teams
            this.resetBtn();
        } else {
            const filteredTeams = this.filterTeams(teams, checkedValues);
            this.listCount(filteredTeams, true);
            this.listBody(filteredTeams, true);
            googleMap.loadMapMarkers(filteredTeams);
            showElementFlex('clear-btn');
        }
    }

    filterMobileEventHandler() {
        this.filterEventHandler();
        this.ensureMobileListState();
    }

    searchBoxClearEventHandler() {
        if ($('#search-box').val().length <= 0) {
            this.clearSearchInput();
            $('#search-results').html('');
        }
    }

    ensureMobileListState() {

        var mapBtn = document.getElementById(this.btnMapElement).style.display;

        if (mapBtn !== "none" && mapBtn !== "") {
            var listOuter = document.getElementById(this.listOuterElement).style.display;
            if (listOuter === "") {
                showElement(this.listOuterElement);
            }
        }
    }

    searchPanelState() {
        hideElement(this.filterDropdown);
        let x = document.getElementContextById("panel-search");
        if (x.style.display === "none") {
            x.style.display = "block";
        } else {
            this.refreshPanelState();
        }
    }

    refreshPanelState() {
        hideElement(this.panelSearch);
        this.clearSearchInput();
        $('#search-results').html('');
    }

    clearSearchInput() {
        document.getElementById("search-box").value = '';
    }

    mapList(teamsList, isFiltered) {
        this.listHeader(teamsList, isFiltered); 
        this.listBody(teamsList, isFiltered);
        this.verifyPanelState();
    }

    navigateBackToList() {
        var isDetailPane = $('#details').css('display');
        if (isDetailPane !== "none") {
            $('#map-back-btn').click();
        }
    }

    verifyPanelState() {
        if (isMobile()) {
            if (!xPrizeMap.mobileToggle) {
                showElementFlex(this.btnlistElement);
                hideElement(this.btnMapElement);
            } else {
                showElementFlex(this.btnMapElement);
                hideElement(this.btnlistElement);
            }
        }
    }

    listBody(teamsList, isFiltered) {
        var listBody = "#list-body";
        $(listBody).html('');
        let source = document.getElementById("listBodyTemplate").innerHTML;
        let template = Handlebars.compile(source);
        let context = {
            teams: teamsList,
            totalTeams: teams.length,
            totalFiltered: teamsList.length,
            isFiltered: isFiltered
        };
        let html = template(context);
        $(listBody).html(html);
    }

    listHeader(teamsList, isFiltered) {
        var listHeader = "#list-header";
        $(listHeader).html('');
        let source = document.getElementInnerHtmlByIdContext("listHeaderTemplate");
        let template = Handlebars.compile(source);
        let context = {
            statuses: this.uniqueBy(teams, "status"),
            location: this.uniqueBy(teams, "location"),
            solutions: this.uniqueListBy(teams, "solutions"),
            achievements: this.uniqueObjectListBy(teams, "achievements", "displayName"),
            totalTeams: teams.length,
            totalFiltered: teamsList.length,
            isFiltered: isFiltered
        };

        let html = template(context);
        $(listHeader).html(html);
    }

    listCount(teamsList, isFiltered) {

        var listCount = "#map-list-total-count-section";
        $(listCount).html('');
        let source = document.getElementInnerHtmlByIdContext("listCountTemplate");
        let template = Handlebars.compile(source);
        let context = {
            totalTeams: teams.length,
            totalFiltered: teamsList.length,
            isFiltered: isFiltered
        };
        let html = template(context);
        $(listCount).html(html);
    }

    uniqueBy(arr, prop) {
        return arr.reduce((a, d) => {
            if (!a.includes(d[prop]) && d[prop] !== null) {
                a.push(d[prop]);
            }
            return a;
        }, []);
    }
    uniqueListBy(arr, prop) {
        return arr.reduce((a, d) => {
            if (!a.includes(d[prop])) {
                if (d[prop].length > 0) {
                    d[prop].forEach(function (v) {
                        if (!a.includes(v)) {
                            a.push(v)
                        }
                    })
                }
            }
            return a;
        }, []);
    }

    uniqueObjectListBy(arr, prop, prop2) {
        return arr.reduce((a, d) => {
            if (d[prop] != null && !a.includes(d[prop][prop2])) {
                if (d[prop].length > 0) {
                    d[prop].forEach(function (v) {
                        if (!a.includes(v[prop2])) {
                            a.push(v[prop2])
                        }
                    })
                }
            }
            return a;
        }, []);
    }



    /* When the user clicks on the button,
    toggle between hiding and showing the dropdown content */
    showFilter() {
        if (document.getElementContextById(this.upChevron).style.display === "none") { //up arrow hidden
            hideElement(this.downChevron);
            showElementInline(this.upChevron);
            showElementBlock(this.filterDropdown);
        } else { // down arrow shown
            showElementInline(this.downChevron);
            hideElement(this.upChevron);
            hideElement(this.filterDropdown);
        }
        hideElement(this.panelSearch);
    }


    resetBtn() {
        this.refreshPanelState();
        this.listBody(this.teams, false);
        this.listCount(this.teams, false);
        googleMap.loadMapMarkers(this.teams);
        $('#filterDropdown input:checkbox').prop('checked', false);
        hideElement('clear-btn');
        xPrizeMap.filteredPlace = null;
        googleMap.recenterMap();
    }

    resetListEventHandler() {
        this.resetBtn();
        
    }

    resetMobileListEventHandler() {
        this.resetListEventHandler();
        this.ensureMobileListState();
    }


    markerDetailsClickEvent(currentMarker) {

        googleMap.navigateToMarker(currentMarker);
    }
    /**
     * Navigates to marker based on team clicked from list
     */
    listTeamClick(teamId) {
        let currentMarker = googleMap.getMapMarker(teamId);
        this.markerDetailsClickEvent(currentMarker);
        xPrizeMap.previousUniqueCluster = currentMarker;
    }
    search() {
        hideElement(this.filterDropdown);
        let x = document.getElementContextById("search-box").value;
        if (x !== '') {
            x = x.toLowerCase();
            let teamResults = teams.filter(o => o.name.toLowerCase().includes(x));
            let placesResults = teams.filter(o => {
                let result = null;
                if (o.address !== null) {
                    result = o.address.toLowerCase().includes(x);
                }
                return result;
            }).map(p => p.address);
            let results = {
                places: [...new Set(placesResults)],
                teams: teamResults
            };
            this.searchResultsTemplate(results);
        } else {
            $('.search-results').html('');
        }
    }
    searchResultsTemplate(results) {
        $('.search-results').html('');
        let source = document.getElementInnerHtmlByIdContext("searchResultsTemplate");
        let template = Handlebars.compile(source);
        let context = {
            teams: results.teams,
            places: results.places,
            hasTeams: (results.teams.length > 0) ? true : false,
            hasPlaces: (results.places.length > 0) ? true : false,
            hasResults: (results.teams.length > 0 || results.places.length) ? true : false
        };
        let html = template(context);
        $('.search-results').html(html);
    }

    filterTeams(teams, values) {

        let filteredTeams = teams;

        var solutionsList = this.uniqueListBy(teams, "solutions");
        var hasSolutions = values.some(sol => solutionsList.includes(sol.split(" ")[0]));

        if (hasSolutions === true) {

            // Step 1: Filter teams by solutions
            filteredTeams = filteredTeams.filter(({ solutions }) => {
                return values.some(sol => solutions.includes(sol)) || values.some(sol => solutions.includes(sol.split(" ")[0]));
            });
        }

        var achievementsList = this.uniqueObjectListBy(teams, "achievements", "displayName")
        var hasAchievements = achievementsList.some(x => values.some(ach => ach == x));

        if (hasAchievements === true) {

            // Step 2: Filter the previously filtered teams by achievements
            filteredTeams = filteredTeams.filter(({ achievements }) => {
                return achievements !== null && achievements.some(x => values.some(ach => ach == x.displayName));
            });
        }

        return this.sortTeamsByLatestAchievement(filteredTeams);
    }

    sortTeamsByLatestAchievement(teams) {
        return teams.sort((a, b) => {
            const latestAchievementA = (a.achievements != null && a.achievements.length > 0) ? new Date(a.achievements[0].achievementDate) : null;
            const latestAchievementB = (b.achievements != null && b.achievements.length > 0) ? new Date(b.achievements[0].achievementDate) : null;

        if (latestAchievementA && latestAchievementB) {
            return latestAchievementB - latestAchievementA;
        }

        if (latestAchievementA) {
            return -1;
        }

        if (latestAchievementB) {
            return 1;
        }

        return 0;
    });
}


}



class MapInit {
    constructor() { }

    StartUp(teams, legendItems) {
        mapLegend = new MapLegendComponent(teams, legendItems);
        mapList = MapListComponent.getInstance(teams);
        googleMap = GoogleMapViewComponent.getInstance(teams);
        this.applyiOSSettings();
    }

    applyiOSSettings() { 
        var ver = this.iOSversion();


        if (ver) {
            if (ver[0] === 14) {
                $('.fa').css("padding-left", "0.5em");
                $('#filterArrowUp').attr('display', 'none');
                $('.fa-chevron-left').attr('style', 'margin-right:0.5em');
            }
            console.log(ver);
        }
    }

    iOSversion() {
        if (/iP(hone|od|ad)/.test(navigator.platform)) {
            var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
            return [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
        }
    }


}

function isMobile() {
    return window.screen.width <= 780;
}
//Helpers
function hideElement(elemId) {
    document.getElementContextById(elemId).style.display = "none";
}

function showElement(elemId) {
    document.getElementContextById(elemId).style.display = "inherit";
}

function showBlockElement(elemId) {
    document.getElementContextById(elemId).style.display = "block";
}

function showElementInline(elemId) {
    document.getElementContextById(elemId).style.display = "inline";
}

function showElementBlock(elemId) {
    document.getElementContextById(elemId).style.display = "Block";
}

function showElementFlex(elemId) {
    document.getElementContextById(elemId).style.display = "flex";
}

function detailsToggle(pixels) {


    var detailHeight = `calc(80vh - ${pixels}px)`;
    var listHeight = `${pixels}px auto`;

    $('#list-header').height(pixels);
    $('#details').height(detailHeight);
    $('#list').css("grid-template-rows", listHeight);
}

//Document Context Extension Methods
//Note: Extensions that help us evaluate between map full screen and map non-full screen context.
Document.prototype.getElementContextById = function (arg) {
    if (xPrizeMap.isFullScreen === true) {
        return $(`#${mapElement} #${arg}`)[0];
    } else {
        return document.getElementById(arg);
    }
};
Document.prototype.getElementContextByClassName = function (arg) {
    if (xPrizeMap.isFullScreen === true) {
        return $(`#${mapElement} .${arg}`)[0];
    } else {
        return document.getElementsByClassName(arg);
    }
};
Document.prototype.queryContextSelectorAll = function (arg) {
    if (xPrizeMap.isFullScreen === true) {
        return $(`#${mapElement} .${arg}`);
    } else {
        return document.querySelectorAll(arg);
    }
};
Document.prototype.getElementInnerHtmlByIdContext = function (arg) {
    if (xPrizeMap.isFullScreen === true) {
        return $(`#${arg}`)[0].innerHTML;
    } else {
        return document.getElementById(arg).innerHTML;
    }
};
Document.prototype.getElementInnerHtmlByClassNameContext = function (arg) {
    if (xPrizeMap.isFullScreen === true) {
        return $(`.${arg}`)[0].innerHTML;
    } else {
        return document.getElementsByClassName(arg).innerHTML;
    }
};